
import { Injectable } from '@angular/core';
import { Department } from '@app/shared/models/admin/department';
import { HttpClientService } from 'app/core/http-client/http-client.service';
import { services } from 'app/core/settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManageDepartmentService {

  private static readonly endpoint = 'Department';
  constructor(private http: HttpClientService) { }

  list(body:any) {
    return this.http.post(body,`${ManageDepartmentService.endpoint}/GetDepartmentPagginatedList`, undefined, services.orderService)
  }

  create(model: Object): Observable<Department> {
    return this.http.post(model, `${ManageDepartmentService.endpoint}/Create`, undefined, services.orderService);
  }

  update(model: object): Observable<any> {
    return this.http.put(model, `${ManageDepartmentService.endpoint}/Update`, services.orderService);
  }

  delete(id: number) {
    return this.http.delete<boolean>(`${ManageDepartmentService.endpoint}/Delete/${id}`, undefined, services.orderService);
  }
}
